import { WindowService } from '@shared/window/window.service';
import { inject, Injectable } from '@angular/core';
import { ConfigurationWizardComponent } from '../configuration-wizard.component';
import { WizardModel } from '../models/wizard-model';

@Injectable({providedIn: 'root'})
export class ConfigurationCreationWizardPresenter {

  private readonly windowService = inject(WindowService);

  public openWizard(openedFromDashboard: boolean, wizardModel?: WizardModel) {
    const bsModalRef = this.windowService.showModalFullscreen(
      ConfigurationWizardComponent, {openedFromDashboard},
    );
    if (wizardModel) {
      bsModalRef.content?.startConfigurationWizard(wizardModel);
    }
  }
}
